import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import API from "../../services/api";
import { SlTabGroup, SlTab, SlIconButton, SlTooltip, SlInput } from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";
import { SlButton } from "@shoelace-style/shoelace/dist/react";
import LineItemsTableView from "../lineItems/LineItemsTableView";
import Paginator from "../../shared/Paginator";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import DateWise from "./DateWise";
import CreativeWise from './CreativeWise'
import { BrandsTypes, roles } from "../../utils/constants";
import TableLoader from "../../shared/TableLoader";
import { formatDateDDMMYYY, formatDateWithTime, ISODateString } from "../../utils/dateFormat";
import CreativeDateWise from "./CreativeDateWise";
import config from "../../config";
import { debounce } from "../../utils/Debounce";

function AddLineItem() {
  const order_id = useParams()
  const props = useLocation().state?.order
  const navigate = useNavigate();
  const [lineItemData, setLineItemData] = useState([]);
  const [show, setShow] = useState(true);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const lineItemsFlag = useSelector((state) => state.Head.lineItemsFlag);
  const [tablePermissions, setTablePermissions] = useState(props.permissions);
  const [searchText, setSearchText] = useState('')

  const [orderStats, setOrderStats] = useState(props.impressionData);
  const [tab, setTab] = useState(localStorage.getItem("role") === roles.ops ||
  localStorage.getItem("role") === roles.financer ?  "lineItem" : localStorage.getItem('email') && !config.CUSTOM_ADVS?.includes(localStorage.getItem('email')) ? "creative" : "dateWise");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const [creativeReportDetails, setCreativeReportDetails] = useState(null)
  const [prefillingData, setPrefillingData] = useState({})
  const handleClose = () => {
    setShow(false);
    navigate("/home/order");
  };
  const getlineItemData = async () => {
    setLoader(true);
    const response = await API({
      url: `/lineitems/getLineItemsByOrder`,
      method: "POST",
      responseType: "json",
      data: {
        order_id: props.order_id,
        searchText: searchText ? searchText : undefined,
        limit: 5,
        offset: currentPage * 5,
      },
    });
    if (response?.code !== 200) {
    } else {
      setLineItemData(response?.data?.data);
      setTotalPages(Math.ceil(response.data.total / 5));
      setLoader(false);
    }
  };
  const getSlotOrderPrefillingData = async () => {
    try {
      const response = await API({
        url: `/slotbooking/get-prefilling-data`,
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id
        },
      });
      if (response.code === 200) {
        let data = response.data
        if(Object.keys(data).length === 0){
          setPrefillingData(null)
          return
        }
        let result = {
          id: order_id.id,
          ...props,
          start: {
          },
          budget: {
          },
          creatselect: {
          },
          date: {
          },
          target: {
          },
        }
        result.action = "add"
        result.start.campaign_name = data.campaign_name || ""
        result.start.brand_id = +data.brand_id || -1
        result.start.campaign_type = data.campaign_type || ""
        result.budget.total_budget = data.total_budget || 0
        result.budget.daily_budget = data.daily_budget || 0
        result.budget.cpm = data.cpm || 0
        result.budget.tot_imp_cap = data.tot_imp_cap || 0
        result.budget.daily_imp_cap = data.daily_imp_cap
        result.creatselect.cpd = data.cpd || 0
        result.creatselect.position = data.position || 0
        result.creatselect.creative_type = data.creative_type || ''
        result.creatselect.sov = data.sov
        result.order_id = order_id.id
        if (data.campaign_type !== 'CPD') {
          result.date.end_date = ISODateString(data.end_date)
          result.date.start_date = ISODateString(data.start_date)
        } else {
          result.date.start = ISODateString(data.start_date)
        }
        let dtime = data.day_time_slots
        for (let i = 0; i < dtime.length; i++) {
          dtime[i]['sdate'] = ISODateString(dtime[i]['sdate'])
          dtime[i]['edate'] = ISODateString(dtime[i]['edate'])
        }
        result.date.datelist = dtime
        result.plusdisable = true
        result.sameday = false
        result.target.state_ids = data.state_ids
        result.target.district_ids = data.district_ids
        result.target.mandal_ids = data.mandal_ids
        result.target.lang_ids = data.lang_ids
        result.target.constituency_ids = data.constituency_ids
        setPrefillingData(result)
      }

    } catch (error) {
      console.error("Error @ getSlotOrderPrefillingData", error)
    }
  }



  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleTab = (type) => {
    setTab(type);
  };

  const calculateCTR = (clciks, imps)=>{
  let ctr =  (clciks / imps) * 100 
  if(isNaN(ctr)){
    return "-"
  }
  else{
    return parseFloat(ctr).toFixed(2)
  }
  }

  useEffect(() => {
    if (props.order_id && tab === "lineItem") {
      if(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson)
      getlineItemData();
    }
  }, [props.order_id, currentPage, lineItemsFlag, searchText, tab]);

  useEffect(() => {
    // getSlotOrderPrefillingData()
  },[props.order_id])

  const csvLinkRef = useRef(); // Create a ref for CSVLink
  let csvHeaders = [
    { label: "Lineitem Id", key: "campaign_id" },
    { label: 'Order Id', key: 'order_id' },
    { label: "Campaign Name", key: "campaign_name" },
    { label: " Campaign Type", key: "campaign_type" },
    { label: "Brand Name", key: "brand_name"},
    { label: "Customer Name", key: "company_name"},
    { label: "GST No", key: "gst_no"},
    { label: "Brand Category", key: "category_name"},
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "Position", key: "position" },
    { label: "Total Budget", key: "total_budget" },
    { label: "Daily Budget", key: "daily_budget" },
    { label: "Sales User Type", key: "new_user_type" },
    { label: "package", key: "package"}
];
// { label: 'CTR(%)', key: 'ctr_percent' },
// { label: 'ECPM/CPD', key: 'ecpm_cpd' },
if (
  localStorage.getItem("role") === roles.ops
) {
    csvHeaders.push({ label: "Adv Impressions", key: "adv_total_imp" });
    csvHeaders.push({ label: "Adv Clicks", key: "adv_total_click" });
    csvHeaders.push({ label: "Adv CTR(%)", key: "adv_ctr" });
    csvHeaders.push({ label: "Adv ECPM/CPD", key: "adv_ecpm" });
    csvHeaders.push({ label: "Impressions", key: "total_imp" });
    csvHeaders.push({ label: "Clicks", key: "total_click" });
    csvHeaders.push({ label: "CTR(%)", key: "ctr_percent" });
    csvHeaders.push({ label: "ECPM/CPD", key: "ecpm_cpd" });
    csvHeaders.push({ label: "Location", key: "location_name" });
    csvHeaders.push({ label: "Sales Person", key: "sales_person_name" });
    csvHeaders.push({ label: "Shares", key: "shares" });
    csvHeaders.push({ label: "Team", key: "team" });
    csvHeaders.push({ label: "Creative Type", key: "creative_type" });
    csvHeaders.push({ label: "Discount Percentage", key: "discount_per" });
    csvHeaders.push({ label: "After Discount", key: "discount_amount" });
    csvHeaders.push({ label: "Actual Price", key: "actual_price" });
    // csvHeaders.push({ label: 'Adv CTR(%)	', key: 'adv_ctr' })
} else {
    csvHeaders.push({ label: "Audience Viewed", key: "total_imp" });
    csvHeaders.push({ label: "Audience Engaged", key: "total_click" });
}
csvHeaders.push({ label: "RO File", key: "rofile_url" });
csvHeaders.push({ label: "Invoice File", key: "invoice_url" });

csvHeaders.push({ label: "Spent", key: "spent" });
if(localStorage.getItem("role") === roles.ops)
  csvHeaders.push({ label: "Adv Spent", key: "adv_spent" });
csvHeaders.push({ label: "Status", key: "status" });
csvHeaders.push({ label: "Target", key: "target" });
  const downloadReport = async (order_id) => {
    setDownloadLoader(true);
    try {
        let result = await API({
            url: "/lineitems/lineItemsReportDownload",
            method: "POST",
            responseType: "json",
            data: {
                sales_ops: { index: 0, value: 0 },
                search: order_id,
                status: -1,
                dateFilter: "",
                campaignType : "all",
                x_filter : 0,
                target_filter : {
                  lang_id: -1,
                  state_id: -1,
                  district_id: -1,
                  mandal_id: -1,
              }
            },
        });
        if (result?.code === 200) {
            setDownloadLoader(false);
            setDownloadData(result.data.data);
        }
    } catch (error) {
        setDownloadLoader(false);
        console.error(error);
        if (error.response.status === 401) navigate("/");
    }
};
const fun3 = (type) => {
  switch (type) {
      case 1:
          return "Created";
      case 2:
          return "Running";
      case 3:
          return "Paused";
      case 4:
          return "Completed";
      default:
          return "Scheduled";
  }
};
useEffect(() => {
  if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
  }
}, [downloadData]);

const handleLineitemSearch = (event) => {
  setCurrentPage(0)
  setSearchText(event.target.value)
}

  return (
    <>
      <Modal show={show} fullscreen={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex gap-2 items-center">
            {localStorage.getItem("role") === roles.ops ||
            localStorage.getItem("role") === roles.financer
              ? "Line Item Details"
              : "Order Details"}
            {tab === "lineItem" ? <SlInput
            placeholder="Search"
            type="text"
            value={searchText}
            onSlInput={debounce(handleLineitemSearch, 1000)}
          ></SlInput> : null}
          </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex gap-1 order-link"
            style={{ textDecoration: "none" }}
          >
            <span onClick={handleClose}>Orders</span>
            <span>&#62;</span>
            <span>{props.orderName}</span>
          </div>
          <table className="order-imps-table">
            <thead>
              <tr>
                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) || (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('impressions')) || localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('impressions')) ? (<th>Impressions</th>) : null}
                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) || (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('clicks')) || localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('clicks')) ? (<th>Clicks</th>) : null}
                {((localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.financer) || (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('ctr')) || localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('ctr')) ? (<th>CTR</th>) : null}
              </tr>
            </thead>
            <tbody>
              <tr>
                {(localStorage.getItem("role") === roles.ops) ?
               <>
                <td>{Math.floor(orderStats?.adv_total_imp || 0)}</td>
                <td>{Math.floor(orderStats?.adv_total_click || 0)}</td>
                <td>
                  {calculateCTR(orderStats?.adv_total_click,orderStats?.adv_total_imp )}
                </td>
                </> :
                <>
                    {((localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('impressions')) || (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('impressions')) || localStorage.getItem("role") === roles.financer) ? (<td>{Math.floor(orderStats?.adv_total_imp || 0)}</td>) : null}
                    {((localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('clicks')) || (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('clicks')) || localStorage.getItem("role") === roles.financer) ? (<td>{Math.floor(orderStats?.adv_total_click || 0)}</td>) : null}
                    {((localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('ctr')) || (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('ctr')) || localStorage.getItem("role") === roles.financer) ? (<td>
                  {calculateCTR(orderStats?.adv_total_click,orderStats?.adv_total_imp )}
                    </td>) : null}
                </>
                }
              </tr>
            </tbody>
          </table>
          <SlTabGroup>
            {localStorage.getItem("role") === roles.ops ||
            localStorage.getItem("role") === roles.financer ? (
              <>
                <SlTab
                  slot="nav"
                  panel="general"
                  onClick={() => handleTab("lineItem")}
                >
                  Line Item Wise
                </SlTab>
                <SlTab
                  slot="nav"
                  panel="all"
                  onClick={() => handleTab("dateWise")}
                >
                  DateWise
                </SlTab>{" "}
                <SlTab
                slot="nav"
                panel="all"
                onClick={() => handleTab("creative")}
              >
                Creative Wise
              </SlTab>{" "}
              {creativeReportDetails && <SlTab
                  slot="nav"
                  panel="all"
                  onClick={() => handleTab("creativedatewise")}
                >
                  {creativeReportDetails?.creative_name}
                </SlTab>}
              </>
            ) : (
                <>
              { (!config.CUSTOM_ADVS?.includes(localStorage.getItem('email'))) ? <SlTab
                slot="nav"
                panel="all"
                onClick={() => handleTab("creative")}
              >
                Creative Wise
              </SlTab> : null}
              {creativeReportDetails && <SlTab
                  slot="nav"
                  panel="all"
                  onClick={() => handleTab("creativedatewise")}
                >
                  {creativeReportDetails?.creative_name}
                </SlTab>}
                  {(props.permissions.includes("impressions") ||
                    props.permissions.includes("spent") ||
                    props.permissions.includes("clicks")) ? (
                    <SlTab
                      slot="nav"
                      panel="all"
                      onClick={() => handleTab("dateWise")}
                    >
                      DateWise
                    </SlTab>
                  ) : null}

                </>
            )}
          </SlTabGroup>
          {tab === "lineItem" && (
            <div>
              <h2 className="text-center">Line Items of "{props.orderName}"</h2>

              <div className="d-flex justify-end mt-2 gap-2">
              {(localStorage.getItem('role') === roles.ops || localStorage.getItem('role') === roles.financer) && <div>
                                <CSVLink
                                    data={downloadData.map(
                                        ({
                                            campaign_name,
                                            campaign_type,
                                            start_date,
                                            end_date,
                                            position,
                                            total_budget,
                                            daily_budget,
                                            total_imp,
                                            total_click,
                                            status,
                                            cpd,
                                            impclicks,
                                            cpc_price,
                                            cpm,
                                            location_name,
                                            sales_person_name,
                                            team,
                                            creative_type,
                                            target,adv_spent,total_spent,order_id, brand_name, category_name, company_name,
                                            gst_no,
                                            campaign_id,
                                            invoice_url,
                                            rofile_url,
                                            discount_obj,
                                            new_user_type,
                                            package_number,
                                            package_weeks
                                        }) => {
                                            const startDate = formatDateWithTime(start_date);
                                            const endDate = formatDateWithTime(end_date);
                                            const campaign_status = fun3(status);
                                            const total =
                                                campaign_type === "CPD" ? cpd : total_budget;
                                            const daily =
                                                campaign_type === "CPD" ? cpd : daily_budget;
                                            // const imps = impclicks[0]?.total_imp ? impclicks[0]?.total_imp : 0;

                                            const imps =
                                            localStorage.getItem("role") === roles.ops
                                                    ? impclicks[0]?.total_imp
                                                        ? impclicks[0]?.total_imp
                                                        : 0
                                                    : parseInt(
                                                        impclicks[0]?.adv_total_imp
                                                            ? impclicks[0]?.adv_total_imp
                                                            : 0
                                                    );
                                            const clicks =
                                            localStorage.getItem("role") === roles.ops
                                                    ? impclicks[0]?.total_click
                                                        ? impclicks[0]?.total_click
                                                        : 0
                                                    : parseInt(
                                                        impclicks[0]?.adv_total_click
                                                            ? impclicks[0]?.adv_total_click
                                                            : 0
                                                    );
                                            const shares = impclicks[0]?.shares
                                                ? impclicks[0]?.shares
                                                : 0;
                                            const ctr =
                                                impclicks[0]?.total_click > 0 &&
                                                    impclicks[0]?.total_imp > 0
                                                    ? (
                                                        (impclicks[0].total_click /
                                                            impclicks[0].total_imp) *
                                                        100
                                                    ).toFixed(2)
                                                    : 0;
                                            const ecpm =
                                                campaign_type === "CPC" &&
                                                    impclicks[0]?.total_click > 0 &&
                                                    impclicks[0]?.total_imp > 0
                                                    ? (
                                                        ((cpc_price * impclicks[0].total_click) /
                                                            impclicks[0].total_imp) *
                                                        1000
                                                    ).toFixed(2)
                                                    : campaign_type === "CPM" &&
                                                        impclicks[0]?.total_imp > 0
                                                        ? (
                                                            ((cpm * impclicks[0].total_imp) /
                                                                1000 /
                                                                impclicks[0].total_imp) *
                                                            1000
                                                        ).toFixed(2)
                                                        : campaign_type === "CPD"
                                                            ? cpd
                                                            : 0;

                                        const adv_ctr =
                                          impclicks[0]?.adv_total_click > 0 &&
                                            impclicks[0]?.adv_total_imp > 0
                                            ? (
                                              (impclicks[0].adv_total_click /
                                                impclicks[0].adv_total_imp) *
                                              100
                                            ).toFixed(2)
                                            : 0;
                                        const adv_ecpm =
                                          campaign_type === "CPC" &&
                                            impclicks[0]?.adv_total_click > 0 &&
                                            impclicks[0]?.adv_total_imp > 0
                                            ? (
                                              ((cpc_price * impclicks[0].adv_total_click) /
                                                impclicks[0].adv_total_imp) *
                                              1000
                                            ).toFixed(2)
                                            : campaign_type === "CPM" &&
                                              impclicks[0]?.adv_total_imp > 0
                                              ? (
                                                ((cpm * impclicks[0].adv_total_imp) /
                                                  1000 /
                                                  impclicks[0].adv_total_imp) *
                                                1000
                                              ).toFixed(2)
                                              : campaign_type === "CPD"
                                                ? cpd
                                                : 0;
                                            let obj = {
                                                campaign_name,
                                                campaign_type,
                                                start_date: startDate,
                                                end_date: endDate,
                                                position,
                                                total_budget: total,
                                                daily_budget: daily,
                                                total_imp: imps,
                                                total_click: clicks,
                                                spent: total_spent,
                                                status: campaign_status,
                                                order_id,
                                                brand_name,
                                                category_name,
                                                company_name,
                                                gst_no,
                                                campaign_id,
                                                invoice_url,
                                                rofile_url,
                                                new_user_type: new_user_type === -1 ? "Main User" : BrandsTypes.find(i => i.value === new_user_type)?.label || "",
                                                package: package_number && package_weeks ? `${package_number} of ${package_weeks}` : ''
                                            };
                                            if (
                                              localStorage.getItem("role") === roles.ops
                                            ) {
                                                obj.shares = shares;
                                                obj.ctr_percent = ctr;
                                                obj.ecpm_cpd = ecpm;
                                                obj.location_name = location_name;
                                                obj.sales_person_name = sales_person_name;
                                                obj.team = team;
                                                obj.creative_type = creative_type;
                                                obj.adv_total_imp = impclicks[0]?.adv_total_imp
                                                obj.adv_total_click = impclicks[0]?.adv_total_click
                                                obj.adv_spent = adv_spent
                                                obj.adv_ctr = adv_ctr
                                                obj.adv_ecpm = adv_ecpm
                                                obj.discount_per = discount_obj?.discount_no || '-'
                                                obj.discount_amount = discount_obj?.discountPrice || '-'
                                                obj.actual_price = discount_obj?.actualPrice || '-'
                                            }
                                            let resultTarget = "";
                                            Object.keys(target).map((key) => {
                                                resultTarget =
                                                    resultTarget + `${key} : ${target[key]} \,`;
                                            });
                                            obj.target = resultTarget;
                                            return obj;
                                        }
                                    )}
                                    headers={csvHeaders}
                                    filename={`${props.orderName}_lineitems_reports.csv`}
                                    ref={csvLinkRef} // Assign the ref to the CSVLink component
                                ></CSVLink>

                                {downloadLoader ? (
                                    <TableLoader />
                                ) : (
                                    <SlTooltip content="Download LineItem Reports">
                                        <SlIconButton
                                            library="lucide"
                                            name="download"
                                            onClick={() => {
                                                downloadReport(props.order_id)
                                            }}
                                        ></SlIconButton>
                                    </SlTooltip>
                                )}
                            </div>}
               {localStorage.getItem('role') === roles.ops && <SlButton
                  size="small"
                  variant="primary"
                  onClick={() => {
                    navigate("/home/campaign/start", {
                      state: {
                        action: "add",
                        order: {
                          id: order_id.id,
                          ...props,
                        },
                        prefillingData
                      },
                    });
                  }}
                >
                  New Line Item
                </SlButton>}
              </div>
              <div className="my-5">
                <LineItemsTableView data={lineItemData} loader={loader}  dateFilter={null}/>
                <div className="flex justify-end">
                  {totalPages > 1 && (
                    <Paginator
                      pageCount={totalPages}
                      handlePageClick={handlePageClick}
                      forcePage={currentPage}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {tab === "dateWise" && <DateWise order_id={props.order_id} permissions={props.permissions} />}
          {
            tab === "creative" && <CreativeWise order_id={props.order_id} permissions={props.permissions} setCreativeReportDetails={setCreativeReportDetails}/>
          }
          {
            tab === "creativedatewise" && creativeReportDetails && <CreativeDateWise order_id={props.order_id} permissions={props.permissions} creative_id={creativeReportDetails?.creative_id} />
          }
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddLineItem;
